import { Chip as MUIChip } from '@mui/material';
import 'app/agriculture/forms/components/Chip/AutocompleteChip.scss';
import { ReactElement } from 'react';

interface AutocompleteChipProps {
    label: string;
    icon?: ReactElement;
    avatar?: ReactElement;
    onDelete?: (event: never) => void;
}

export function AutocompleteChip(props: AutocompleteChipProps) {
    const { avatar, icon, label, onDelete } = props;
    return (
        <MUIChip
            data-testid="AutocompleteChip"
            className="AutocompleteChip"
            classes={{
                icon: 'AutocompleteChip__icon',
                deleteIcon: 'AutocompleteChip__delete-icon',
            }}
            label={label}
            icon={icon}
            avatar={avatar}
            variant="filled"
            onDelete={onDelete}
        />
    );
}
